export enum StatusType {
    ORDER = 'order',
    QUOTE = 'quote',
}

export enum OrderType {
    RESALE = 'RSL',
    STOCK = 'STK'
}

export type OrderTypeKey = keyof typeof OrderType;

export const ORDER_TYPE_KEYS = new Map<OrderType, OrderTypeKey>(
    Object.entries(OrderType).map(([key, value]: [OrderTypeKey, OrderType]) => [value, key])
);

export enum QuoteStatus {
    EDIT = 'EDIT',
    ACCEPT = 'ACCEPT',
    ADDITIONAL = 'ADDITIONAL',
    MERGE = 'MERGE',
    PARTIAL = 'PARTIAL',
    FULL = 'FULL',
    REJECT = 'REJECT',
    PARTIALREJECT = 'PARTIALREJECT',
    ADDITIONALFULL = 'ADDITIONALFULL',
    ADDITIONALPARTIAL = 'ADDITIONALPARTIAL'
}

export enum CurrentQuoteStatus {
    PENDING = 'PENDING',
    OPEN = 'OPEN'
}